import { Injectable } from '@angular/core';
import { SpanAttributes, SpanOptions } from '@opentelemetry/api';
import { ObservabilityService } from './observability-service';
import { LocalStorageService, MetaTags, MetaTagsService } from '@mode/shared/util-js';
import { PerformanceService } from './performance-service';

@Injectable({ providedIn: 'root' })
export class ReportCreationObservabilityService {
  private _endTrace: Function = () => {};

  constructor(
    private observabilityService: ObservabilityService,
    private metaTagsService: MetaTagsService,
    private performanceService: PerformanceService
  ) {}

  public startTrace(traceName: 'create-new-report-with-query' | 'create-new-report-with-dataset'): void {
    this._endTrace = () => {
      const defaultAttrs: SpanAttributes = {
        'mode.webapp_ui.current_username': this.metaTagsService.getTag(MetaTags.CurrentUsername) ?? 'not-available',
        'mode.webapp_ui.owner_username': this.metaTagsService.getTag(MetaTags.OwnerUsername) ?? 'not-available',
      };

      this.observabilityService
        .startTrace(traceName, {
          startTime: this.performanceService.timeOrigin,
          attributes: this.observabilityService.createSpanAttributes(defaultAttrs),
        })
        .end();
    };
  }

  public endTrace(): void {
    this._endTrace();
    this._endTrace = () => {};
  }
}
